/* eslint-disable */
export default {
  _Background: 'Background',
  _BackgroundBottom: 'BackgroundBottom',
  _SeaMonster: 'SeaMonster',
  _ClamSpeechBubble: 'ClamSpeechBubble',
  _RoundIndicatorBg: 'RoundIndicatorBg',
  _Friend_1_Outline: 'Friend_1_Outline',
  _ResultsMessageBg: 'ResultsMessageBg',
  _Friend_1: 'Friend_1',
  _Friends_0: 'Friends/0',
  _Friends_1: 'Friends/1',
  _Friend_3_Outline: 'Friend_3_Outline',
  _Friend_3: 'Friend_3',
  _Friend_2_Outline: 'Friend_2_Outline',
  _Friends_115: 'Friends/115',
  _Friends_116: 'Friends/116',
  _Friends_117: 'Friends/117',
  _Friends_118: 'Friends/118',
  _BtnGo: 'BtnGo',
  _Friend_2: 'Friend_2',
  _Friends_35: 'Friends/35',
  _Friends_39: 'Friends/39',
  _Friends_37: 'Friends/37',
  _Friends_28: 'Friends/28',
  _Friends_119: 'Friends/119',
  _ClamTalker: 'ClamTalker',
  _NumberBox: 'NumberBox',
  _Friends_224: 'Friends/224',
  _Friends_225: 'Friends/225',
  _AllFishes_51: 'AllFishes/51',
  _AllFishes_103: 'AllFishes/103',
  _Friends_73: 'Friends/73',
  _Friends_74: 'Friends/74',
  _Friends_251: 'Friends/251',
  _Friends_114: 'Friends/114',
  _Friends_75: 'Friends/75',
  _Friends_239: 'Friends/239',
  _Friends_252: 'Friends/252',
  _Friends_76: 'Friends/76',
  _Friends_77: 'Friends/77',
  _Friends_97: 'Friends/97',
  _Friends_23: 'Friends/23',
  _Friends_24: 'Friends/24',
  _Friends_50: 'Friends/50',
  _Friends_25: 'Friends/25',
  _Friends_49: 'Friends/49',
  _Friends_36: 'Friends/36',
  _Friends_38: 'Friends/38',
  _Friends_34: 'Friends/34',
  _Friends_40: 'Friends/40',
  _Friends_78: 'Friends/78',
  _Friends_79: 'Friends/79',
  _Friends_32: 'Friends/32',
  _Friends_42: 'Friends/42',
  _Friends_94: 'Friends/94',
  _Friends_95: 'Friends/95',
  _Friends_101: 'Friends/101',
  _Friends_96: 'Friends/96',
  _Friends_120: 'Friends/120',
  _Friends_80: 'Friends/80',
  _Friends_121: 'Friends/121',
  _Friends_81: 'Friends/81',
  _Friends_122: 'Friends/122',
  _Friends_112: 'Friends/112',
  _Friends_82: 'Friends/82',
  _Friends_83: 'Friends/83',
  _Friends_113: 'Friends/113',
  _Friends_123: 'Friends/123',
  _Friends_90: 'Friends/90',
  _Friends_124: 'Friends/124',
  _Friends_283: 'Friends/283',
  _Friends_91: 'Friends/91',
  _Friends_92: 'Friends/92',
  _Friends_93: 'Friends/93',
  _Friends_33: 'Friends/33',
  _Friends_41: 'Friends/41',
  _Friends_84: 'Friends/84',
  _Friends_85: 'Friends/85',
  _Friends_104: 'Friends/104',
  _Friends_105: 'Friends/105',
  _Friends_106: 'Friends/106',
  _Friends_107: 'Friends/107',
  _Friends_125: 'Friends/125',
  _Friends_126: 'Friends/126',
  _Friends_127: 'Friends/127',
  _Friends_128: 'Friends/128',
  _Friends_72: 'Friends/72',
  _Friends_274: 'Friends/274',
  _Friends_100: 'Friends/100',
  _Friends_102: 'Friends/102',
  _Friends_103: 'Friends/103',
  _Friends_108: 'Friends/108',
  _Friends_129: 'Friends/129',
  _Friends_130: 'Friends/130',
  _Friends_280: 'Friends/280',
  _Friends_275: 'Friends/275',
  _Friends_240: 'Friends/240',
  _Friends_131: 'Friends/131',
  _Friends_98: 'Friends/98',
  _Friends_281: 'Friends/281',
  _Friends_109: 'Friends/109',
  _Friends_110: 'Friends/110',
  _Friends_99: 'Friends/99',
  _Friends_87: 'Friends/87',
  _Friends_111: 'Friends/111',
  _Friends_88: 'Friends/88',
  _Friends_89: 'Friends/89',
  _Friends_86: 'Friends/86',
  _Friends_284: 'Friends/284',
  _Friends_31: 'Friends/31',
  _Friends_43: 'Friends/43',
  _Friends_30: 'Friends/30',
  _Friends_44: 'Friends/44',
  _Friends_285: 'Friends/285',
  _Friends_46: 'Friends/46',
  _Friends_29: 'Friends/29',
  _Friends_45: 'Friends/45',
  _Friends_26: 'Friends/26',
  _Friends_48: 'Friends/48',
  _Friends_27: 'Friends/27',
  _Friends_47: 'Friends/47',
  _Friends_286: 'Friends/286',
  _Friends_287: 'Friends/287',
  _ResultsTail: 'ResultsTail',
  _Friends_137: 'Friends/137',
  _Friends_136: 'Friends/136',
  _Friends_288: 'Friends/288',
  _Friends_310: 'Friends/310',
  _Friends_321: 'Friends/321',
  _Friends_311: 'Friends/311',
  _Friends_289: 'Friends/289',
  _Friends_312: 'Friends/312',
  _Friends_290: 'Friends/290',
  _AllFishes_325: 'AllFishes/325',
  _Friends_291: 'Friends/291',
  _Friends_282: 'Friends/282',
  _Friends_292: 'Friends/292',
  _Friends_293: 'Friends/293',
  _Friends_294: 'Friends/294',
  _Friends_295: 'Friends/295',
  _Friends_296: 'Friends/296',
  _Friends_276: 'Friends/276',
  _Friends_277: 'Friends/277',
  _Friends_278: 'Friends/278',
  _AllFishes_216: 'AllFishes/216',
  _Friends_138: 'Friends/138',
  _Friends_135: 'Friends/135',
  _AllFishes_322: 'AllFishes/322',
  _Friends_279: 'Friends/279',
  _Friends_297: 'Friends/297',
  _AllFishes_326: 'AllFishes/326',
  _Friends_237: 'Friends/237',
  _Friends_238: 'Friends/238',
  _AllFishes_154: 'AllFishes/154',
  _BubbleMakerIcon: 'BubbleMakerIcon',
  _AllFishes_323: 'AllFishes/323',
  _Friends_298: 'Friends/298',
  _Friends_313: 'Friends/313',
  _AllFishes_179: 'AllFishes/179',
  _AllFishes_2: 'AllFishes/2',
  _AllFishes_1: 'AllFishes/1',
  _AllFishes_130: 'AllFishes/130',
  _Hand_Pointer: 'Hand_Pointer',
  _AllFishes_104: 'AllFishes/104',
  _Friends_250: 'Friends/250',
  _Friends_253: 'Friends/253',
  _Friends_254: 'Friends/254',
  _Friends_273: 'Friends/273',
  _Friends_241: 'Friends/241',
  _Friends_249: 'Friends/249',
  _Friends_255: 'Friends/255',
  _Friends_271: 'Friends/271',
  _Friends_272: 'Friends/272',
  _Friends_248: 'Friends/248',
  _Friends_256: 'Friends/256',
  _Friends_257: 'Friends/257',
  _Friends_270: 'Friends/270',
  _Friends_258: 'Friends/258',
  _Friends_242: 'Friends/242',
  _Friends_247: 'Friends/247',
  _Friends_259: 'Friends/259',
  _Friends_268: 'Friends/268',
  _AllFishes_324: 'AllFishes/324',
  _Friends_269: 'Friends/269',
  _Friends_243: 'Friends/243',
  _Friends_245: 'Friends/245',
  _Friends_299: 'Friends/299',
  _Friends_134: 'Friends/134',
  _AllFishes_329: 'AllFishes/329',
  _Friends_246: 'Friends/246',
  _Friends_260: 'Friends/260',
  _Friends_261: 'Friends/261',
  _Friends_263: 'Friends/263',
  _Friends_264: 'Friends/264',
  _Friends_139: 'Friends/139',
  _Friends_267: 'Friends/267',
  _Friends_244: 'Friends/244',
  _Friends_262: 'Friends/262',
  _Friends_265: 'Friends/265',
  _Friends_266: 'Friends/266',
  _AllFishes_135: 'AllFishes/135',
  _Friends_132: 'Friends/132',
  _Friends_133: 'Friends/133',
  _AllFishes_330: 'AllFishes/330',
  _Friends_140: 'Friends/140',
  _AllFishes_327: 'AllFishes/327',
  _AllFishes_328: 'AllFishes/328',
  _AllFishes_143: 'AllFishes/143',
  _AllFishes_258: 'AllFishes/258',
  _AllFishes_33: 'AllFishes/33',
  _AllFishes_108: 'AllFishes/108',
  _AllFishes_265: 'AllFishes/265',
  _AllFishes_289: 'AllFishes/289',
  _AllFishes_253: 'AllFishes/253',
  _AllFishes_284: 'AllFishes/284',
  _AllFishes_314: 'AllFishes/314',
  _Friends_317: 'Friends/317',
  _AllFishes_131: 'AllFishes/131',
  _Friends_318: 'Friends/318',
  _Friends_319: 'Friends/319',
  _Friends_320: 'Friends/320',
  _Friends_300: 'Friends/300',
  _Friends_333: 'Friends/333',
  _Friends_361: 'Friends/361',
  _Friends_301: 'Friends/301',
  _Friends_303: 'Friends/303',
  _Friends_304: 'Friends/304',
  _Friends_305: 'Friends/305',
  _Friends_327: 'Friends/327',
  _Friends_306: 'Friends/306',
  _Friends_307: 'Friends/307',
  _Friends_308: 'Friends/308',
  _MenuArrow: 'MenuArrow',
  _Friends_309: 'Friends/309',
  _Friends_314: 'Friends/314',
  _Friends_315: 'Friends/315',
  _Friends_316: 'Friends/316',
  _AllFishes_192: 'AllFishes/192',
  _Friends_322: 'Friends/322',
  _Friends_323: 'Friends/323',
  _Friends_324: 'Friends/324',
  _AllFishes_167: 'AllFishes/167',
  _Friends_325: 'Friends/325',
  _Friends_142: 'Friends/142',
  _Friends_150: 'Friends/150',
  _Friends_326: 'Friends/326',
  _Friends_328: 'Friends/328',
  _Friends_329: 'Friends/329',
  _Friends_332: 'Friends/332',
  _Friends_334: 'Friends/334',
  _Friends_14: 'Friends/14',
  _AllFishes_129: 'AllFishes/129',
  _AllFishes_155: 'AllFishes/155',
  _Bubble_1: 'Bubble_1',
  _AllFishes_116: 'AllFishes/116',
  _AllFishes_147: 'AllFishes/147',
  _AllFishes_40: 'AllFishes/40',
  _Friends_335: 'Friends/335',
  _AllFishes_117: 'AllFishes/117',
  _AllFishes_268: 'AllFishes/268',
  _Friends_340: 'Friends/340',
  _Friends_341: 'Friends/341',
  _AllFishes_298: 'AllFishes/298',
  _Friends_2: 'Friends/2',
  _AllFishes_189: 'AllFishes/189',
  _Friends_3: 'Friends/3',
  _AllFishes_226: 'AllFishes/226',
  _Friends_302: 'Friends/302',
  _Friends_330: 'Friends/330',
  _Friends_331: 'Friends/331',
  _Friends_336: 'Friends/336',
  _AllFishes_105: 'AllFishes/105',
  _AllFishes_286: 'AllFishes/286',
  _Friends_4: 'Friends/4',
  _Friends_5: 'Friends/5',
  _AllFishes_106: 'AllFishes/106',
  _AllFishes_23: 'AllFishes/23',
  _AllFishes_21: 'AllFishes/21',
  _AllFishes_118: 'AllFishes/118',
  _Friends_352: 'Friends/352',
  _countmark_2: 'countmark_2',
  _Friends_353: 'Friends/353',
  _Friends_359: 'Friends/359',
  _Friends_360: 'Friends/360',
  _Friends_337: 'Friends/337',
  _AllFishes_254: 'AllFishes/254',
  _Friends_6: 'Friends/6',
  _AllFishes_285: 'AllFishes/285',
  _AllFishes_126: 'AllFishes/126',
  _Friends_7: 'Friends/7',
  _Friends_338: 'Friends/338',
  _Friends_8: 'Friends/8',
  _ResultMark_incorrect: 'ResultMark_incorrect',
  _AllFishes_200: 'AllFishes/200',
  _Friends_339: 'Friends/339',
  _Friends_9: 'Friends/9',
  _Friends_342: 'Friends/342',
  _Friends_10: 'Friends/10',
  _AllFishes_134: 'AllFishes/134',
  _AllFishes_158: 'AllFishes/158',
  _Friends_343: 'Friends/343',
  _Friends_344: 'Friends/344',
  _Friends_345: 'Friends/345',
  _Friends_346: 'Friends/346',
  _Friends_347: 'Friends/347',
  _Friends_348: 'Friends/348',
  _AllFishes_13: 'AllFishes/13',
  _AllFishes_65: 'AllFishes/65',
  _AllFishes_6: 'AllFishes/6',
  _Friends_349: 'Friends/349',
  _Friends_350: 'Friends/350',
  _countmark_5: 'countmark_5',
  _Friends_351: 'Friends/351',
  _Friends_354: 'Friends/354',
  _Friends_355: 'Friends/355',
  _AllFishes_267: 'AllFishes/267',
  _AllFishes_297: 'AllFishes/297',
  _Friends_356: 'Friends/356',
  _AllFishes_171: 'AllFishes/171',
  _AllFishes_287: 'AllFishes/287',
  _AllFishes_237: 'AllFishes/237',
  _AllFishes_283: 'AllFishes/283',
  _AllFishes_107: 'AllFishes/107',
  _AllFishes_266: 'AllFishes/266',
  _AllFishes_132: 'AllFishes/132',
  _AllFishes_213: 'AllFishes/213',
  _AllFishes_75: 'AllFishes/75',
  _AllFishes_288: 'AllFishes/288',
  _countmark_4: 'countmark_4',
  _AllFishes_115: 'AllFishes/115',
  _AllFishes_269: 'AllFishes/269',
  _AllFishes_259: 'AllFishes/259',
  _ResultMark_correct: 'ResultMark_correct',
  _AllFishes_156: 'AllFishes/156',
  _Friends_11: 'Friends/11',
  _Friends_22: 'Friends/22',
  _Friends_141: 'Friends/141',
  _AllFishes_49: 'AllFishes/49',
  _AllFishes_101: 'AllFishes/101',
  _Friends_151: 'Friends/151',
  _Friends_152: 'Friends/152',
  _Friends_181: 'Friends/181',
  _Friends_182: 'Friends/182',
  _Friends_183: 'Friends/183',
  _Friends_188: 'Friends/188',
  _Friends_189: 'Friends/189',
  _Friends_190: 'Friends/190',
  _Friends_219: 'Friends/219',
  _Friends_220: 'Friends/220',
  _Friends_221: 'Friends/221',
  _AllFishes_48: 'AllFishes/48',
  _AllFishes_18: 'AllFishes/18',
  _AllFishes_70: 'AllFishes/70',
  _AllFishes_19: 'AllFishes/19',
  _AllFishes_7: 'AllFishes/7',
  _AllFishes_17: 'AllFishes/17',
  _AllFishes_212: 'AllFishes/212',
  _AllFishes_210: 'AllFishes/210',
  _AllFishes_247: 'AllFishes/247',
  _Friends_153: 'Friends/153',
  _Friends_154: 'Friends/154',
  _Friends_155: 'Friends/155',
  _Friends_178: 'Friends/178',
  _Friends_179: 'Friends/179',
  _Friends_180: 'Friends/180',
  _Friends_191: 'Friends/191',
  _Friends_192: 'Friends/192',
  _Friends_193: 'Friends/193',
  _Friends_216: 'Friends/216',
  _Friends_217: 'Friends/217',
  _Friends_218: 'Friends/218',
  _AllFishes_256: 'AllFishes/256',
  _AllFishes_257: 'AllFishes/257',
  _AllFishes_299: 'AllFishes/299',
  _AllFishes_133: 'AllFishes/133',
  _AllFishes_296: 'AllFishes/296',
  _AllFishes_35: 'AllFishes/35',
  _AllFishes_229: 'AllFishes/229',
  _AllFishes_152: 'AllFishes/152',
  _AllFishes_127: 'AllFishes/127',
  _AllFishes_24: 'AllFishes/24',
  _AllFishes_76: 'AllFishes/76',
  _AllFishes_255: 'AllFishes/255',
  _AllFishes_58: 'AllFishes/58',
  _AllFishes_119: 'AllFishes/119',
  _AllFishes_4: 'AllFishes/4',
  _AllFishes_157: 'AllFishes/157',
  _AllFishes_159: 'AllFishes/159',
  _AllFishes_144: 'AllFishes/144',
  _AllFishes_168: 'AllFishes/168',
  _AllFishes_270: 'AllFishes/270',
  _AllFishes_188: 'AllFishes/188',
  _AllFishes_300: 'AllFishes/300',
  _AllFishes_140: 'AllFishes/140',
  _AllFishes_42: 'AllFishes/42',
  _AllFishes_313: 'AllFishes/313',
  _AllFishes_315: 'AllFishes/315',
  _AllFishes_73: 'AllFishes/73',
  _AllFishes_92: 'AllFishes/92',
  _AllFishes_136: 'AllFishes/136',
  _AllFishes_160: 'AllFishes/160',
  _AllFishes_16: 'AllFishes/16',
  _AllFishes_68: 'AllFishes/68',
  _AllFishes_11: 'AllFishes/11',
  _AllFishes_22: 'AllFishes/22',
  _AllFishes_63: 'AllFishes/63',
  _Friends_149: 'Friends/149',
  _Friends_51: 'Friends/51',
  _Friends_143: 'Friends/143',
  _AllFishes_74: 'AllFishes/74',
  _AllFishes_211: 'AllFishes/211',
  _AllFishes_321: 'AllFishes/321',
  _AllFishes_20: 'AllFishes/20',
  _AllFishes_249: 'AllFishes/249',
  _AllFishes_8: 'AllFishes/8',
  _AllFishes_25: 'AllFishes/25',
  _AllFishes_26: 'AllFishes/26',
  _AllFishes_59: 'AllFishes/59',
  _AllFishes_60: 'AllFishes/60',
  _AllFishes_9: 'AllFishes/9',
  _AllFishes_3: 'AllFishes/3',
  _AllFishes_54: 'AllFishes/54',
  _AllFishes_69: 'AllFishes/69',
  _AllFishes_55: 'AllFishes/55',
  _AllFishes_53: 'AllFishes/53',
  _Friends_144: 'Friends/144',
  _AllFishes_27: 'AllFishes/27',
  _AllFishes_71: 'AllFishes/71',
  _AllFishes_72: 'AllFishes/72',
  _AllFishes_109: 'AllFishes/109',
  _AllFishes_77: 'AllFishes/77',
  _AllFishes_78: 'AllFishes/78',
  _AllFishes_14: 'AllFishes/14',
  _AllFishes_290: 'AllFishes/290',
  _AllFishes_114: 'AllFishes/114',
  _AllFishes_28: 'AllFishes/28',
  _AllFishes_56: 'AllFishes/56',
  _Friends_227: 'Friends/227',
  _AllFishes_15: 'AllFishes/15',
  _AllFishes_187: 'AllFishes/187',
  _AllFishes_61: 'AllFishes/61',
  _AllFishes_66: 'AllFishes/66',
  _AllFishes_67: 'AllFishes/67',
  _AllFishes_12: 'AllFishes/12',
  _AllFishes_64: 'AllFishes/64',
  _AllFishes_79: 'AllFishes/79',
  _AllFishes_112: 'AllFishes/112',
  _AllFishes_122: 'AllFishes/122',
  _AllFishes_141: 'AllFishes/141',
  _AllFishes_263: 'AllFishes/263',
  _AllFishes_5: 'AllFishes/5',
  _AllFishes_150: 'AllFishes/150',
  _AllFishes_137: 'AllFishes/137',
  _AllFishes_161: 'AllFishes/161',
  _AllFishes_145: 'AllFishes/145',
  _AllFishes_169: 'AllFishes/169',
  _AllFishes_146: 'AllFishes/146',
  _AllFishes_170: 'AllFishes/170',
  _AllFishes_120: 'AllFishes/120',
  _AllFishes_138: 'AllFishes/138',
  _AllFishes_10: 'AllFishes/10',
  _AllFishes_293: 'AllFishes/293',
  _AllFishes_197: 'AllFishes/197',
  _AllFishes_224: 'AllFishes/224',
  _AllFishes_110: 'AllFishes/110',
  _AllFishes_234: 'AllFishes/234',
  _Friends_19: 'Friends/19',
  _Friends_20: 'Friends/20',
  _Friends_21: 'Friends/21',
  _Friends_156: 'Friends/156',
  _Friends_157: 'Friends/157',
  _Friends_158: 'Friends/158',
  _Friends_176: 'Friends/176',
  _Friends_177: 'Friends/177',
  _Friends_194: 'Friends/194',
  _Friends_195: 'Friends/195',
  _Friends_196: 'Friends/196',
  _Friends_214: 'Friends/214',
  _Friends_215: 'Friends/215',
  _Friends_159: 'Friends/159',
  _Friends_160: 'Friends/160',
  _Friends_161: 'Friends/161',
  _Friends_173: 'Friends/173',
  _Friends_174: 'Friends/174',
  _Friends_197: 'Friends/197',
  _Friends_198: 'Friends/198',
  _Friends_199: 'Friends/199',
  _Friends_211: 'Friends/211',
  _Friends_212: 'Friends/212',
  _Friends_162: 'Friends/162',
  _Friends_163: 'Friends/163',
  _Friends_170: 'Friends/170',
  _Friends_171: 'Friends/171',
  _Friends_200: 'Friends/200',
  _Friends_201: 'Friends/201',
  _Friends_208: 'Friends/208',
  _Friends_209: 'Friends/209',
  _AllFishes_316: 'AllFishes/316',
  _AllFishes_100: 'AllFishes/100',
  _AllFishes_31: 'AllFishes/31',
  _AllFishes_32: 'AllFishes/32',
  _AllFishes_83: 'AllFishes/83',
  _AllFishes_84: 'AllFishes/84',
  _AllFishes_193: 'AllFishes/193',
  _AllFishes_230: 'AllFishes/230',
  _AllFishes_46: 'AllFishes/46',
  _AllFishes_98: 'AllFishes/98',
  _AllFishes_45: 'AllFishes/45',
  _AllFishes_87: 'AllFishes/87',
  _AllFishes_34: 'AllFishes/34',
  _AllFishes_47: 'AllFishes/47',
  _AllFishes_86: 'AllFishes/86',
  _AllFishes_99: 'AllFishes/99',
  _AllFishes_38: 'AllFishes/38',
  _AllFishes_191: 'AllFishes/191',
  _AllFishes_90: 'AllFishes/90',
  _AllFishes_196: 'AllFishes/196',
  _AllFishes_80: 'AllFishes/80',
  _AllFishes_62: 'AllFishes/62',
  _AllFishes_113: 'AllFishes/113',
  _AllFishes_97: 'AllFishes/97',
  _AllFishes_260: 'AllFishes/260',
  _AllFishes_36: 'AllFishes/36',
  _AllFishes_294: 'AllFishes/294',
  _AllFishes_37: 'AllFishes/37',
  _AllFishes_0: 'AllFishes/0',
  _AllFishes_88: 'AllFishes/88',
  _AllFishes_185: 'AllFishes/185',
  _AllFishes_190: 'AllFishes/190',
  _AllFishes_281: 'AllFishes/281',
  _AllFishes_89: 'AllFishes/89',
  _AllFishes_50: 'AllFishes/50',
  _Friends_147: 'Friends/147',
  _AllFishes_225: 'AllFishes/225',
  _AllFishes_52: 'AllFishes/52',
  _AllFishes_311: 'AllFishes/311',
  _Friends_148: 'Friends/148',
  _AllFishes_228: 'AllFishes/228',
  _AllFishes_278: 'AllFishes/278',
  _AllFishes_102: 'AllFishes/102',
  _AllFishes_57: 'AllFishes/57',
  _AllFishes_264: 'AllFishes/264',
  _AllFishes_295: 'AllFishes/295',
  _AllFishes_111: 'AllFishes/111',
  _AllFishes_262: 'AllFishes/262',
  _AllFishes_292: 'AllFishes/292',
  _AllFishes_29: 'AllFishes/29',
  _AllFishes_81: 'AllFishes/81',
  _AllFishes_194: 'AllFishes/194',
  _AllFishes_30: 'AllFishes/30',
  _AllFishes_261: 'AllFishes/261',
  _AllFishes_162: 'AllFishes/162',
  _AllFishes_291: 'AllFishes/291',
  _AllFishes_85: 'AllFishes/85',
  _countmark_3: 'countmark_3',
  _AllFishes_82: 'AllFishes/82',
  _AllFishes_44: 'AllFishes/44',
  _RoundIndicator_off: 'RoundIndicator_off',
  _RoundIndicator_on: 'RoundIndicator_on',
  _AllFishes_320: 'AllFishes/320',
  _AllFishes_250: 'AllFishes/250',
  _Friends_164: 'Friends/164',
  _Friends_202: 'Friends/202',
  _AllFishes_208: 'AllFishes/208',
  _AllFishes_319: 'AllFishes/319',
  _Friends_165: 'Friends/165',
  _Friends_166: 'Friends/166',
  _Friends_168: 'Friends/168',
  _Friends_169: 'Friends/169',
  _Friends_203: 'Friends/203',
  _Friends_204: 'Friends/204',
  _Friends_206: 'Friends/206',
  _Friends_207: 'Friends/207',
  _AllFishes_186: 'AllFishes/186',
  _Friends_167: 'Friends/167',
  _Friends_205: 'Friends/205',
  _AllFishes_245: 'AllFishes/245',
  _AllFishes_195: 'AllFishes/195',
  _Friends_228: 'Friends/228',
  _AllFishes_233: 'AllFishes/233',
  _AllFishes_232: 'AllFishes/232',
  _Friends_172: 'Friends/172',
  _Friends_210: 'Friends/210',
  _Friends_229: 'Friends/229',
  _AllFishes_165: 'AllFishes/165',
  _Friends_52: 'Friends/52',
  _Friends_53: 'Friends/53',
  _Friends_54: 'Friends/54',
  _countmark_1: 'countmark_1',
  _AllFishes_96: 'AllFishes/96',
  _AllFishes_317: 'AllFishes/317',
  _AllFishes_175: 'AllFishes/175',
  _AllFishes_248: 'AllFishes/248',
  _AllFishes_227: 'AllFishes/227',
  _AllFishes_231: 'AllFishes/231',
  _AllFishes_39: 'AllFishes/39',
  _AllFishes_43: 'AllFishes/43',
  _AllFishes_271: 'AllFishes/271',
  _AllFishes_273: 'AllFishes/273',
  _AllFishes_301: 'AllFishes/301',
  _AllFishes_121: 'AllFishes/121',
  _AllFishes_308: 'AllFishes/308',
  _AllFishes_149: 'AllFishes/149',
  _AllFishes_303: 'AllFishes/303',
  _AllFishes_128: 'AllFishes/128',
  _AllFishes_164: 'AllFishes/164',
  _AllFishes_279: 'AllFishes/279',
  _AllFishes_142: 'AllFishes/142',
  _AllFishes_151: 'AllFishes/151',
  _AllFishes_309: 'AllFishes/309',
  _AllFishes_166: 'AllFishes/166',
  _Friends_175: 'Friends/175',
  _Friends_213: 'Friends/213',
  _Friends_184: 'Friends/184',
  _Friends_185: 'Friends/185',
  _Friends_186: 'Friends/186',
  _Friends_187: 'Friends/187',
  _Friends_222: 'Friends/222',
  _Friends_223: 'Friends/223',
  _Friends_226: 'Friends/226',
  _Friends_12: 'Friends/12',
  _Friends_13: 'Friends/13',
  _Friends_15: 'Friends/15',
  _Friends_16: 'Friends/16',
  _Friends_17: 'Friends/17',
  _Friends_18: 'Friends/18',
  _AllFishes_181: 'AllFishes/181',
  _AllFishes_218: 'AllFishes/218',
  _AllFishes_94: 'AllFishes/94',
  _AllFishes_202: 'AllFishes/202',
  _AllFishes_91: 'AllFishes/91',
  _AllFishes_95: 'AllFishes/95',
  _AllFishes_222: 'AllFishes/222',
  _AllFishes_209: 'AllFishes/209',
  _AllFishes_223: 'AllFishes/223',
  _AllFishes_41: 'AllFishes/41',
  _AllFishes_93: 'AllFishes/93',
  _AllFishes_180: 'AllFishes/180',
  _AllFishes_217: 'AllFishes/217',
  _AllFishes_239: 'AllFishes/239',
  _AllFishes_183: 'AllFishes/183',
  _AllFishes_184: 'AllFishes/184',
  _AllFishes_246: 'AllFishes/246',
  _AllFishes_220: 'AllFishes/220',
  _Friends_55: 'Friends/55',
  _Friends_56: 'Friends/56',
  _Friends_57: 'Friends/57',
  _Friends_58: 'Friends/58',
  _Friends_59: 'Friends/59',
  _Friends_60: 'Friends/60',
  _Friends_61: 'Friends/61',
  _Friends_62: 'Friends/62',
  _Friends_63: 'Friends/63',
  _Friends_64: 'Friends/64',
  _Friends_65: 'Friends/65',
  _Friends_66: 'Friends/66',
  _Friends_67: 'Friends/67',
  _Friends_68: 'Friends/68',
  _Friends_69: 'Friends/69',
  _Friends_70: 'Friends/70',
  _Friends_71: 'Friends/71',
  _Friends_230: 'Friends/230',
  _Friends_231: 'Friends/231',
  _Friends_235: 'Friends/235',
  _Friends_236: 'Friends/236',
  _Friends_232: 'Friends/232',
  _Friends_234: 'Friends/234',
  _Friends_233: 'Friends/233',
  _AllFishes_318: 'AllFishes/318',
  _Friends_145: 'Friends/145',
  _Friends_146: 'Friends/146',
  _Friends_357: 'Friends/357',
  _Friends_358: 'Friends/358',
  _AllFishes_139: 'AllFishes/139',
  _AllFishes_163: 'AllFishes/163',
  _AllFishes_182: 'AllFishes/182',
  _AllFishes_173: 'AllFishes/173',
  _AllFishes_272: 'AllFishes/272',
  _AllFishes_198: 'AllFishes/198',
  _AllFishes_302: 'AllFishes/302',
  _AllFishes_148: 'AllFishes/148',
  _AllFishes_219: 'AllFishes/219',
  _AllFishes_172: 'AllFishes/172',
  _AllFishes_235: 'AllFishes/235',
  _AllFishes_221: 'AllFishes/221',
  _AllFishes_174: 'AllFishes/174',
  _AllFishes_277: 'AllFishes/277',
  _AllFishes_307: 'AllFishes/307',
  _AllFishes_282: 'AllFishes/282',
  _AllFishes_312: 'AllFishes/312',
  _AllFishes_176: 'AllFishes/176',
  _AllFishes_201: 'AllFishes/201',
  _AllFishes_177: 'AllFishes/177',
  _AllFishes_153: 'AllFishes/153',
  _AllFishes_178: 'AllFishes/178',
  _AllFishes_238: 'AllFishes/238',
  _AllFishes_205: 'AllFishes/205',
  _AllFishes_242: 'AllFishes/242',
  _AllFishes_123: 'AllFishes/123',
  _AllFishes_214: 'AllFishes/214',
  _AllFishes_274: 'AllFishes/274',
  _AllFishes_304: 'AllFishes/304',
  _AllFishes_280: 'AllFishes/280',
  _AllFishes_252: 'AllFishes/252',
  _AllFishes_310: 'AllFishes/310',
  _AllFishes_124: 'AllFishes/124',
  _AllFishes_199: 'AllFishes/199',
  _AllFishes_236: 'AllFishes/236',
  _AllFishes_203: 'AllFishes/203',
  _AllFishes_240: 'AllFishes/240',
  _AllFishes_275: 'AllFishes/275',
  _AllFishes_215: 'AllFishes/215',
  _AllFishes_305: 'AllFishes/305',
  _AllFishes_125: 'AllFishes/125',
  _AllFishes_276: 'AllFishes/276',
  _AllFishes_204: 'AllFishes/204',
  _AllFishes_306: 'AllFishes/306',
  _AllFishes_241: 'AllFishes/241',
  _AllFishes_251: 'AllFishes/251',
  _AllFishes_206: 'AllFishes/206',
  _AllFishes_207: 'AllFishes/207',
  _AllFishes_243: 'AllFishes/243',
  _AllFishes_244: 'AllFishes/244',
}